var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeHeroLeaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 421,
    height: 151,
    viewBox: "0 0 421 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1429",
    "data-name": "Rectangle 1429",
    width: 421,
    height: 151,
    transform: "translate(198 627)",
    fill: "#e0c6a3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    width: 300.84,
    height: 284.724,
    fill: "#996b59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1426-2",
    "data-name": "Rectangle 1426",
    width: 190.673,
    height: 180.458,
    fill: "#afc620"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_25",
    "data-name": "Groupe de masques 25",
    transform: "translate(-198 -627)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1004",
    "data-name": "Groupe 1004",
    transform: "translate(209.126 642.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1000",
    "data-name": "Groupe 1000",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_999",
    "data-name": "Groupe 999",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_969",
    "data-name": "Trac\\xE9 969",
    d: "M300.84,251.521v33.2C143.823,284.724,14.8,159.794,0,0,173.339,30.036,300.84,131.264,300.84,251.521",
    transform: "translate(0 0)",
    fill: "#996b59"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1001",
    "data-name": "Groupe 1001",
    transform: "translate(205.504 57.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_999-2",
    "data-name": "Groupe 999",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_969-2",
    "data-name": "Trac\\xE9 969",
    d: "M0,159.414v21.044c99.517,0,181.294-79.181,190.673-180.458C80.811,19.037,0,83.2,0,159.414",
    transform: "translate(0 0)",
    fill: "#afc620"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeroLeaves);
export default __webpack_public_path__ + "static/media/home-hero-leaves.e225fac7fbf08c6a512a964b0b055972.svg";
export { ForwardRef as ReactComponent };